import moment from 'moment';
import { formatDurationAsHMS } from '../../../../../../common/formatting';
import { DeveloperGame } from '../userDeveloperSubmission-graphql';
import { COLORS } from '../../../../../../common/Styleguide/Common/colors';
import { SUBMISSION_STATUS } from '@crazygames/game-types/src/submission/submission-status.type';

export function formatAvgPlaytime(game: DeveloperGame) {
  return formatDurationAsHMS(moment.duration(game.devStats.analytics.avgTimeOnPage, 'seconds'));
}

export function getStatusColor(status: SUBMISSION_STATUS): string {
  switch (status) {
    case 'REQUIRES_APPROVAL':
    case 'BASIC_LAUNCH_REQUIRES_APPROVAL':
    case 'AWAITING_DEVELOPER_CHANGE':
    case 'PREPARING_RELEASE':
    case 'SYNC_REQUIRED':
    case 'NEW_SUBMISSION':
    case 'NEW_BUSINESS_REVIEW':
    case 'UNDER_BUSINESS_REVIEW':
    case 'BASIC_LAUNCH_SYNC_REQUIRED':
    case 'BASIC_LAUNCH_MIXED_RESULT':
    case 'BASIC_LAUNCH_MIXED_RESULT_SYNC_REQUIRED':
    case 'BASIC_LAUNCH_AWAITING_DEVELOPER_CHANGE':
    case 'BASIC_LAUNCH_APPROVED':
      return COLORS.warning[100];
    case 'RELEASED':
    case 'BASIC_LAUNCH':
      return COLORS.success[100];
    case 'REJECTED':
    case 'FINALIZED': // displayed as "Archived"
      return COLORS.alert[100];
    case 'DRAFT':
      return COLORS.white[60];
  }
}
